(function ($) {
  'use strict';
  this.LaVuelta2022 = function () {
    document.addEventListener('DOMContentLoaded', function () {
      if (window.dispatchEventType) {
        window.dispatchEventType(
          document,
          'SkodaAnalytics:Promotions:AddElements',
          undefined,
          undefined,
          undefined,
          {
            elements: document.querySelectorAll('#product-banner a'),
            context: 'La Vuelta 2022',
          }
        );
      }
    });
  };
}).bind(window)(jQuery);
